import React from 'react';
import { useTranslator } from 'static/script/app/lang';

const BankIdErrorMessage = ({ bankIdErrorMessage }) => {
    const { t } = useTranslator();
    return (
        <div className="receipt align-center">
            <div className="icon-error" />
            <h1 className="h4 font-weight-bold">
                {t('bankIdModal_ErrorTitle')}
            </h1>
            <article>{bankIdErrorMessage}</article>
        </div>
    );
};
export default BankIdErrorMessage;
